import { atom } from 'jotai'
import { QUERY_KEY_PRICE } from 'services/query-v2/keys'
import { DEFAULT_REFETCH_INTERVAL } from 'services/query-v2/refetch-intervals'
import { createAtomsWithQuery } from '../atomic-factory'
import {
  defaultPriceRequest,
  getPHTRUSDPrice,
  parseQuotePrice,
  PriceRequest,
  PriceRequestAtoms,
  PriceResponse,
} from './model'

const stakingPriceQuery = async <T>({
  queryKey: [, params],
}: {
  queryKey: [string, PriceRequest]
}) => {
  const PHTRPrice = await getPHTRUSDPrice()
  return parseQuotePrice(params, PHTRPrice) as T
}

export const PHTRPriceFactory = () => {
  const priceRequestParamsAtom = atom<PriceRequest>(defaultPriceRequest)

  const mainProperties = createAtomsWithQuery<
    PriceResponse,
    PriceRequest,
    null,
    null,
    [string, PriceRequest]
  >(
    { first: priceRequestParamsAtom },
    QUERY_KEY_PRICE,
    stakingPriceQuery<PriceResponse>,
    DEFAULT_REFETCH_INTERVAL,
    'stakingPriceQuery',
  )

  return { params: priceRequestParamsAtom, ...mainProperties } as PriceRequestAtoms
}
